import { render } from "./CardModal.vue?vue&type=template&id=dbd16aaa"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"
script.render = render

export default script